module.exports = __webpack_public_path__ + "img/centro6.73bc18d0.jpg";